export default __webpack_public_path__ + "static/media/sport-blue.x1.c08a721d.svg";